let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("u2Avf"), load("65Ttu")]).then(() => parcelRequire('ek8yD'));